export default function createBidsObjectFromKeywords(keywords) {
  return keywords.map(keyword => ({
    keyword,
    priceOffer: null,
    matchType: null,
  }));
}
